import { Carousel } from "primereact/carousel";
import React, { useEffect, useState } from "react";
import "../styles/home.css";
import RemoteStoreTypes from "./remote-store-types";
import SpecialRemoteStores from "./special-remote-stores";
import { getToken } from "../utils/utility";
import ServiceController from "../services/service-controller";
import UserController from "../services/user-controller";

export default function Home(props) {
    const serviceController = new ServiceController();
    const userController = new UserController();
    //const localizer = t;
    const [banners, setBanners] = useState([]);
    const [isLogin, setIsLogin] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLogin(getToken() != null);
        getData();
    }, []);

    const getData = async function () {
        try {
            //> Get banners
            const bannersResult = await serviceController.getBanners();
            if (bannersResult.isSuccess === false) throw bannersResult.message;
            setBanners(bannersResult.value);
        } catch (error) {
            alert(error.toString());
        }
    };

    const autoLoginToReservation =async function () {
        try {
            setIsLoading(true);
            await userController.autoLogin("https://offplus.ir/درخواست-اقامتگاه")
        } catch (error) {
            alert(error.toString());
        }
        setIsLoading(false);
    }

    const bannerTemplate = (banner) => {
        return (
            <div className="banner">
                <img src={banner.imageUrl} alt={banner.name} />
            </div>
        );
    };

    return (
        <>
            <Carousel
                value={banners}
                numVisible={1}
                numScroll={1}
                itemTemplate={bannerTemplate}
                autoplayInterval={7000}
                circular
            />

            <div className="quick-access">
                <ul>
                    <li>
                        <a href="/#/login">
                            <i className="pi pi-sign-in"></i>
                            <span>عضویت</span>
                            <p>ورود به باشگاه مشتریان</p>
                        </a>
                    </li>
                    <li>
                        <a href="/#/register">
                            <i className="pi pi-user-edit"></i>
                            <span>کمپین ها</span>
                            <p>برای استفاده از امکانات بیشتر اطلاعات خود را تکمیل نمایید</p>
                        </a>
                    </li>
                    <li>
                        <a href="/#/register">
                            <i className="pi pi-heart"></i>
                            <span>مراکز مورد علاقه</span>
                            <p>معرفی مراکر معتبر مورد علاقه</p>
                        </a>
                    </li>
                    <li>
                        {isLogin === true ? (
                            <a href="/#/" onClick={(e) => { e.preventDefault(); autoLoginToReservation() }} className={isLoading ? "loading" :""}>
                                <i className="pi pi-wallet"></i>
                                <span>مراکز اقامتی و تفریحی</span>
                                <p>رزرو اماکن اقامتی و تفریحی</p>
                            </a>
                        ) : (
                            <a href="/#/login">
                                <i className="pi pi-wallet"></i>
                                <span>مراکز اقامتی و تفریحی</span>
                                <p>رزرو اماکن اقامتی و تفریحی</p>
                            </a>
                        )}
                    </li>
                    <li>
                        <a href="https://ble.ir/taxi_offplus" target="_blank" rel="noreferrer">
                            <i className="pi pi-send"></i>
                            <span>کانال بله</span>
                            <p>اخبار و اطلاع رسانی باشگاه در پیام رسان بله</p>
                        </a>
                    </li>
                    <li>
                        <a href="https://eitaa.com/taxi_tehran" target="_blank" rel="noreferrer">
                            <i className="pi pi-comments"></i>
                            <span>کانال ایتا</span>
                            <p>اخبار و اطلاع رسانی باشگاه در پیام رسان ایتا</p>
                        </a>
                    </li>
                </ul>
            </div>

            <SpecialRemoteStores />
            <RemoteStoreTypes />
        </>
    );
}
